import { bool, node, string } from "prop-types";

import styled from "styled-components";

const A = styled("a")`
  color: ${({ $color, theme: { palette, colors } }) =>
    colors[$color] || palette[$color] || $color} !important;
  ${({ $underlineOnHover }) =>
    $underlineOnHover
      ? "text-decoration: none; &:hover {text-decoration: underline;}"
      : ""}
`;

/**
 * Drop this inside a FnrTypography tag to have the text style and color be the standard.
 *
 * @param {object} param0
 * @param {string} param0.href - the link to navigate to
 * @param {boolean} param0.underlineOnHover - matches legacy effect of only underlining link text on hover.
 * @param {color} param0.color - for when you want a different color.
 */
const FnrTextLink = ({
  href,
  underlineOnHover,
  color = "blue",
  children,
  ...rest
}) => {
  if (!children) return null;
  if (!href) return children;
  return (
    <A
      href={href}
      $underlineOnHover={underlineOnHover}
      $color={color}
      target="_blank"
      rel="noreferrer"
      {...rest}
    >
      {children}
    </A>
  );
};
FnrTextLink.propTypes = {
  href: string,
  underlineOnHover: bool,
  children: node,
  color: string,
};

export default FnrTextLink;
